export enum DocumentStatusEnum {
    BUFFOR = 0,
    APPROVED = 1,
    CANCELED = 2,
    CORRECTION = 3,
}